export const HUB_PEOPLE_PAGE_SIZE = 10;

export function cityPagePeoplePageSize(isMobile) {
  return isMobile ? 20 : 50;
}

export function resolveHubOutcome(resolution) {
  if (!resolution?.page) {
    return resolveSwitchedOffOutcome(resolution);
  }
  if (resolution.redirectToSlug) {
    return { redirect: { status: 301, slug: resolution.redirectToSlug } };
  }
  return { page: resolution.page };
}

export function resolveSwitchedOffOutcome(resolution, citySeoName = null) {
  if (resolution?.page || !resolution?.redirectToProfessionSeoName) {
    return null;
  }
  return {
    redirect: {
      status: 301,
      slug: resolution.redirectToProfessionSeoName,
      ...(citySeoName ? { citySeoName } : {}),
    },
  };
}

export function resolveEmptyHubOutcome(page) {
  if (page.cities.length) {
    return null;
  }
  return { redirect: { status: 302, slug: page.profession.seoName } };
}

export function resolveCityOutcome({ slug, result, peopleTotal }) {
  if (!result) {
    return null;
  }
  if (result.page.slug !== slug) {
    return {
      redirect: {
        status: 301,
        slug: result.page.slug,
        citySeoName: result.city.seoName,
      },
    };
  }
  if (!result.enabled) {
    return { redirect: { status: 301, slug: result.page.slug } };
  }
  if (peopleTotal !== undefined && !peopleTotal) {
    return { redirect: { status: 302, slug: result.page.slug } };
  }
  return { result };
}

export function professionTaskPagePath(localePath, { slug, citySeoName }) {
  if (citySeoName) {
    return localePath({
      name: "professionals",
      params: { profession: slug, city: citySeoName },
    });
  }
  return localePath({ name: "professionPage", params: { profession: slug } });
}
